import React from "react";
import { Box, Tabs, Tab } from "@mui/material";

const GenericTabs = ({
  tabs,
  activeTab,
  onTabChange,
  showDividers = true,
  tabsProps = {},
  tabProps = {},
  containerProps = {},
}) => {
  return (
    <Box sx={{ width: "100%", my: 1 }} {...containerProps}>
      <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
        <Tabs
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          value={activeTab}
          aria-label="generic tabs"
          className="generic-tabs"
          sx={{
            "& .MuiTab-root": {
              minHeight: 35,
              padding: "5px 10px",
            },
            ...tabsProps.sx,
          }}
          {...tabsProps}
        >
          {tabs.map((tab, index) => (
            <React.Fragment key={tab.value || index}>
              <Tab
                label={tab.label}
                value={tab.value}
                className={tab.className || "text"}
                style={{
                  padding: "10px",
                  ...(tab.width && { width: tab.width }),
                  ...tab.style,
                }}
                onClick={() => onTabChange(tab.value, tab)}
                aria-selected={activeTab === tab.value}
                disabled={tab.disabled || false}
                {...tabProps}
                {...tab.tabProps}
              />
              {showDividers && index < tabs.length - 1 && (
                <div className="tab-divider" />
              )}
            </React.Fragment>
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default GenericTabs;
